import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { observer } from 'mobx-react'
import FieldWrapper from '../layouts/FieldWrapper'
import React from 'react'
import useField from '../hooks/use-field'

function DateField (props) {
  const {
    id,
    name,
    value,
    onChange,
    wrap
  } = useField(props)

  const datePickerProps = {}

  if (props.min) {
    datePickerProps.minDate = moment(props.min, 'YYYY-MM-DD').toDate()
  }

  if (props.max) {
    datePickerProps.maxDate = moment(props.max, 'YYYY-MM-DD').toDate()
  }

  if (props.weekSelect) {
    datePickerProps.showWeekNumbers = true
  }

  if (props.time === true) {
    datePickerProps.showTimeInput = true
  }

  if (props.withPortal === true) {
    datePickerProps.withPortal = true
  }

  return wrap(() => (
    <>
      <input type='hidden' name={name} value={value} />

      <DatePicker
        selected={value ? moment(value, 'YYYY-MM-DD HH:mm:ss').toDate() : null}
        onChange={date => {
          console.log('SELECTED DATE', date)

          const momentDate = moment.utc()

          momentDate.year(date.getFullYear())
          momentDate.months(date.getMonth())
          momentDate.date(date.getDate())

          if (props.time) {
            momentDate.hour(date.getUTCHours())
            momentDate.minute(date.getUTCMinutes())
            momentDate.seconds(date.getUTCSeconds())
          } else {
            momentDate.hour(0)
            momentDate.minute(0)
            momentDate.seconds(0)
          }

          momentDate.millisecond(0)

          console.log('SELECTED DATE', date, momentDate, momentDate.format('YYYY-MM-DD HH:mm:ss'))

          onChange(momentDate.format('YYYY-MM-DD HH:mm:ss'))
        }}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dateFormat={props.format}
        className={props.className}
        placeholderText={props.placeholder}
        dropdownMode='select'

        {...datePickerProps}
      />
    </>
  ))
}

DateField.defaultProps = {
  defaultValue: null,
  placeholder: 'Vælg dato...',
  type: 'text',
  readOnly: false,
  disabled: false,
  required: false,
  className: '',
  format: 'dd.MM.yyyy',
  saveFormat: 'dd.MM.yyyy',
  time: false,
  withPortal: true
}

DateField.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  min: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(moment)
  ]),
  max: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(moment)
  ]),
  format: PropTypes.string,
  saveFormat: PropTypes.string,
  weekSelect: PropTypes.bool,
  time: PropTypes.bool,
  withPortal: PropTypes.bool
}

export default observer(DateField)
